import { Button, Card, Space } from 'antd';
import React from 'react';
import holderImg from '@/assets/images/public/no-permission.svg';
import { useAuthContext } from '@/presentation/hooks';
import style from '@/presentation/pages/product/internal-permission/index.module.scss';
import { useStores } from '@/presentation/store';

const NoPermission = () => {
  const {} = useStores().ProductStore;
  const { authInfo } = useAuthContext();

  return (
    <Card bordered={false} style={{ flex: 1, background: '#f0f2f5' }}>
      <div className={style.holder}>
        <img src={holderImg} alt={''} />
        <h4 className={style.subtitle}>温馨提示</h4>
        <div className={style.subDesc}>
          <p> 尊敬的用户，你当前还没有加入任何Bugly的产品，请联系相关产品的管理员将你添加到项目成员中，或者联系Bugly小助手。</p>
          <p>（你的用户 ID为：{authInfo.userInfo.buglyUserId}，详情请点击右上角头像，查看个人信息。）</p>
        </div>
        <Space>
          <Button style={{ border: 'none', background: '#EBEFF5' }} onClick={() => location.reload()}>刷新</Button>
        </Space>
      </div>
    </Card>
  );
};

export default NoPermission;
